import Vue from 'vue'
import axios from 'axios'
import cookies from '../../libs/util.cookies'


axios.defaults.timeout = 120000
axios.defaults.retry = 3
axios.defaults.retryDelay = 2000
axios.defaults.withCredentials = true

function axiosRerty(err) {
  const config = err.config
  if (!config || !config.retry) {
    return Promise.reject(err)
  }
  config.__retryCount = config.__retryCount || 0
  if (config.__retryCount >= config.retry) {
    return Promise.reject(err)
  }
  config.__retryCount += 1

  const backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve()
    }, config.retryDelay || 1)
  })
  return backoff.then(function() {
    return axios(config)
  })
}

axios.interceptors.request.use(
(config) => {
  if (process.env.NODE_ENV === 'production') {
    // 处理重复
    if (config.url.indexOf('/KYWB') != 0) {
      config.url = '/KYWB' + config.url
    }
    // 地图数据不需要加/nginx前缀
    /* if (config.url.indexOf('map/json/province') > -1) {
      config.url = config.url.substr(4)
    } */
  }
  const token = cookies.get('token')
  // if (config.method === 'get') {
  //   if (config.params) {
  //     config.params.appCode = 'GLYHT'
  //   } else {
  //     config.params = {}
  //     config.params.appCode = 'GLYHT'
  //   }
  // }
  // if (config.method === 'post') {
  //   if (config.data) {
  //     config.data.appCode = 'GLYHT'
  //   } else {
  //     config.data = {}
  //     config.data.appCode = 'GLYHT'
  //   }
  // }
  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + token,
      appCode: 'YHGHT'

    }
  } else {
    config.headers = {
      ...config.headers,
      appCode: 'YHGHT'
    }
  }
  return config
},
(error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(async (res) => {
  if (res.data && res.data.errno == 0) {
    return res.data
  }
  if (res.data.code !== 200 && res.data.code !== 304) {

    if (res.data.code === 10000024 || res.data.message === '需要使用极验验证') {
      return res.data
    }
    if (res.data.code === 705) {
      // 需要刷新token， 但是不用登陆
      axios({
        url: '/auth-server/auth/refresh',
        method: 'GET'
      }).then(refreshRes => {
        if (refreshRes.code === 200 && refreshRes.data) {
          cookies.set('token', refreshRes.data)
        } else {
          cookies.remove('token')
          window.location = window.location.href.split('#')[0] + '#/login'
        }
      })
      return
    }
    if (res.data.code === 1001 || res.data.code === 1002 || res.data.code === 1003) {
      cookies.remove('token')
      window.location = window.location.href.split('#')[0] + '#/login'
      Vue.prototype.$message({
        type: 'error',
        message: res.data.message
      })
      return res.data
    }
    if (res.data.code === 501) {
      Vue.prototype.$message({
        type: 'error',
        message: res.data.message
      })
      return res.data
    } else {
      if (res.data.message === '没有传token' || res.data.message === "token已过期，请重新登录。") {
        cookies.remove('token')
        window.location = window.location.href.split('#')[0] + '#/login'
        /* Vue.prototype.$message({
        	type: 'error',
        	message: res.data.message
        }) */
        return res.data
      }
    }
    Vue.prototype.$message({
      type: 'error',
      message: res.data.message
    })
  }

  return res.data
}, axiosRerty)



export {
  axios as fetch
}

export default {
  install: function(Vue, options) {
    Vue.prototype.$axios = axios
  }
}



// WEBPACK FOOTER //
// ./src/plugin/axios/index.js